export default function ThumbnailImage({src}) {
    return (
        <div className="video_placeholder">
            <img src={src ?? '/image/thum/player_blank_gray.svg'} onError={(e) => e.target.src = '/image/thum/player_blank_gray.svg'} className="video_thum object-cover w-full"/>
        </div>
    )
}